import { Optional } from "common/utils/types";

import { IProfile } from ".";

/** Matches catalog FulfillmentOption */
export type ItemFulfillmentOption = {
  kind: DeliveryMethodKind;
  is_available: boolean;
  is_low_stock: boolean;
  messages: string[];
};

/** Matches catalog DeliveryMethodKind */
export enum DeliveryMethodKind {
  Pickup = "PICKUP",
  Shipping = "SHIPPING",
  Delivery = "DELIVERY",
}

/** Matches fulfillments FulfillmentStatus */
export enum FulfillmentStatus {
  ReadyToPick = "READY_TO_PICK",
  ReadyToReview = "READY_TO_REVIEW",
  ReadyForPickup = "READY_FOR_PICKUP",
  ReadyToShip = "READY_TO_SHIP",
  MissedPickup = "MISSED_PICKUP",
  Completed = "COMPLETED",
  Canceled = "CANCELED",
}

/** Matches fulfillments CommonFulfillmentEventSerializer */
export interface IFulfillmentEvent {
  id: number;
  status: FulfillmentStatus;
  created: string;
  user: IProfile;
  display: string;
  has_late_warning: boolean;
  days_ago_display: string;
  dismissed_at: Optional<string>;
}
